import styled from 'styled-components';
import { Icon, IconButton } from '@web-chat-core/ui-kit';
import { ParticipantItem } from 'features/ParticipantItem';
import { TileIconsContainer } from 'features/ParticipantItem/view';
import { toggleHideWithOpacityAnimation } from 'ui/mixins';

export const ActiveSpeakerButtonView = styled(IconButton)<{ $hidden?: boolean }>`
    cursor: pointer;
    display: flex;
    ${({ $hidden }) => toggleHideWithOpacityAnimation($hidden)};

    &:before {
        background-color: ${({ theme }) => theme.root.colors.basicColors.black['50%']};
        border-radius: 6px;
    }

    &:hover:before {
        background-color: ${({ theme }) => theme.root.colors.background['02Second']};
    }

    &:after {
        left: -10px;
        transform: translateX(-100%) translateY(6px);
        white-space: nowrap;
    }
`;

export const ActiveSpeakerIcon = styled(Icon)`
    position: relative;
`;

export const ActiveSpeakerWindow = styled.div`
    position: relative;
    width: calc(100% / 6 - var(--layout-grid-gap));

    &:hover .moderation-menu-button[data-variant='tile-small'],
    &:has([data-state='open']) .moderation-menu-button[data-variant='tile-small'] {
        opacity: 1;
        width: 24px;
    }

    &:hover ${TileIconsContainer}, &:has([data-state='open']) ${TileIconsContainer} {
        right: 40px;
    }
`;

export const ActiveSpeaker = styled(ParticipantItem)`
    background-color: ${({ theme }) => theme.root.colors.background['01Base']};

    /* по умолчанию — только место под крестик; при ховере/открытом меню — ещё место под троеточие */
    ${TileIconsContainer} {
        right: 32px;
        z-index: 7; /* выше чем CloseButton (z-index: 5) */
    }
`;

export const CloseButton = styled(IconButton)`
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 5;
`;
